import type { GetCustomerSuccessUsers } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useGetCustomerSuccessUsers() {
  return useQuery({
    queryFn: () =>
      apiClient
        .url(`/users/customer-success-users`)
        .get()
        .json<GetCustomerSuccessUsers>(),
    queryKey: ["customer-success-users"],
  });
}
